<template>
  <el-button @click="buttomEvent" v-bind="buttomObject" :plain="buttomObject.plain">{{buttomObject.label}}</el-button>
</template>
<script>
  export default {
    props: {
      buttomObject:{
        type:Object
      }
    },
    data () {
      return {

      }
    },
    methods:{
      buttomEvent() {
        this.$emit(this.buttomObject.buttomEventName,"")
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Buttom/index.vue